import { generateStorageKey } from "@saas/shared/utils/generate-storage-key/generate-storage-key";

export type TGenerateCashierSessionKeyInput = string;

export type TGenerateCashierSessionKeyOutput = string;

export const generateCashierSessionKey = (
  parentId: TGenerateCashierSessionKeyInput
): TGenerateCashierSessionKeyOutput => {
  return generateStorageKey({
    key: "cashier-v2",
    version: 3,
    userId: parentId,
  });
};
